import Api from 'App/api'

export const getReviews = Api.get({
  controller: 'reviews',
  action: 'list',
})

export const saveReview = Api.post({
  controller: 'reviews',
  action: 'save',
})
